import API from '@/api'

export default {
  namespaced: true,

  state: () => ({
    loading: false,
    startDate: null,
    endDate: null,
    lessons: [],
    teacher: null,
  }),

  getters: {
    loading(state) {
      return state.loading
    },

    days(state) {
      return _(state.lessons)
        .map((x) => x.weekday)
        .uniq()
        .orderBy((x) => x)
        .map((w) => {
          const lessons = _(state.lessons)
            .filter((x) => x.weekday === w)
            .orderBy((x) => x.startTimeMin)
            .value()

          return {
            weekday: w,
            times: lessons.map((lesson) => ({
              ...lesson,
              lessons: [lesson],
            })),
          }
        })
        .value()
    },
  },

  mutations: {
    update(state, { lessons, teacher, startDate, endDate }) {
      state.teacher = teacher
      state.lessons = lessons || []
      state.startDate = startDate
      state.endDate = endDate
    },

    updateLoading(state, loading) {
      state.loading = loading
    }
  },

  actions: {
    async fetch({ commit }, data) {
      commit('updateLoading', true)

      const response = await API.getTeacherLessons(data)

      commit('update', response)
      commit('updateLoading', false)

      return response
    },
  }
}
